






































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {pwdCriteria} from '@/helpers/validate-password';

@Component
export default class PasswordStrengthIndicator extends Vue {
  @Prop()
  protected password?: string;

  protected criteria: any = '';

  @Watch('password')
  private onModelChanged(value: string, oldValue: string) {
    this.criteria = pwdCriteria(value);
  }

}
